var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1IrRemoteControler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.32 11.25l-2.64 3a32.58 32.58 0 00-42.88 0l-2.63-3a36.58 36.58 0 0148.15 0zm-41.74 4.6L23 19a25 25 0 0130.43 0l2.44-3.16a29 29 0 00-35.32 0l.03.01zM52 30.88V70a4 4 0 01-4 4H29a4 4 0 01-4-3.75V31a4 4 0 014-4h19a4 4 0 014 3.88zM48 31H29v39h19V31zm-9.76-10a17.7 17.7 0 017.88 1.83l1.77-3.58a21.82 21.82 0 00-19.3 0l1.77 3.58A17.73 17.73 0 0138.24 21zM41 59a2 2 0 104 0 2 2 0 00-4 0zm-2.5-7a2 2 0 100 4 2 2 0 000-4zm0 10a2 2 0 100 4 2 2 0 000-4zM37 46h3v-4h4v-3h-4v-4h-3v4h-4v3h4v4zm-3 15a2 2 0 100-4 2 2 0 000 4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_IR_Remote_controler.d99daf47.svg";
export { SvgG1IrRemoteControler as ReactComponent };